import BasicButton from './BasicButton';

export * from './BasicButtonProps';
export default BasicButton;
